import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import PropTypes from "prop-types"
import { useQuery } from "react-query";
import { Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, FormFeedback } from 'reactstrap';
import { useFormik } from 'formik';
import { getUserProfile } from 'helpers/fakebackend_helper';
import { updateUserDetails } from 'store/actions';

const OnUpdateNameModal = props => {
    const dispatch = useDispatch();
    const [name, setName] = useState(null);
    const { isOpen, toggle, userPhoneNumber } = props;
    const { isLoading, error, data, isFetching } = useQuery({
        queryKey: ["authUser"], queryFn: getUserProfile
    });
    const getName = () => {
        if (data?.name) {
            setName(data?.name);
        }
    }
    useEffect(() => {
        getName();
    }, [data])

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: data?.name ? name : ''
        },
        validate: (values) => {
            const errors = {};
            if (!values.name) {
                errors.name = 'Please Enter your name';
            } else if (
                !/^[a-zA-Z0-9\s]+$/.test(values.name)
            ) {
                errors.name = 'Invalid name';
            }
            return errors;
        },
        onSubmit: (values) => {
            toggle();
            const name = values.name;
            dispatch(updateUserDetails(name, userPhoneNumber))
        }
    })

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle}>
                    Update Name
                </ModalHeader>
                <ModalBody>
                    <Form
                        className='form-horizontal'
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                        }}
                    >
                        <Row>
                            <Col>
                                <div className="custom-flex-container">
                                    <div className="mb-3 custom-flex-item">
                                        <Label className="form-label">Name</Label>
                                        <Input
                                            name="name"
                                            className="input"
                                            placeholder="Enter your name"
                                            type="text"
                                            required
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.name || ""}
                                            invalid={
                                                validation.touched.name && validation.errors.name ? true : false
                                            }
                                        />
                                        {validation.touched.name && validation.errors.name && (
                                            <FormFeedback type="invalid">
                                                {validation.errors.name}
                                            </FormFeedback>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div className="text-end">
                                <button
                                    type="submit"
                                    className="btn btn-success save-user"
                                >
                                    Update
                                </button>
                            </div>
                        </Row>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

OnUpdateNameModal.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
    userPhoneNumber: PropTypes.string,
}

export default OnUpdateNameModal